const simpleSignature = [
  {
    id: 'EDigital',
    name: 'EDigital'
  },
  {
    id: 'Febos',
    name: 'Febos'
  }
];

const advancedSignature = [
  {
    id: 'THSign',
    name: 'Thomas Signe'
  }, {
    id: 'Esign',
    name: 'Esign S.A.'
  },
  {
    id: 'esign7',
    name: 'Esign S.A. (7)'
  },
  {
    id: 'FirmadorMinisterioEconomia',
    name: 'Ministerio economia'
  },
  {
    id: 'Segpres',
    name: 'Segpres'
  }
];

export default {
  simpleSignature,
  advancedSignature
};
